import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CuentasPorCobrarService } from '../../../services/cuentas-por-cobrar.service';
import { FormularioContratoComponent } from './formulario-contrato/formulario-contrato.component';
import { ListadoRentasComponent } from './listado-rentas/listado-rentas.component';
import { ListadoMantenimientosComponent } from './listado-mantenimientos/listado-mantenimientos.component';
import { ListadoServiciosComponent } from './listado-servicios/listado-servicios.component';
import { ListadoArchivosComponent } from './listado-archivos/listado-archivos.component';

@Component({
  selector: 'app-agregar-contrato',
  templateUrl: './agregar-contrato.component.html',
  styleUrls: ['./agregar-contrato.component.scss']
})
export class AgregarContratoComponent implements OnInit {

    public loading:boolean=false;
    public current_tab:number=1;
    @ViewChild(FormularioContratoComponent) formulario_contrato_component: FormularioContratoComponent;
    @ViewChild(ListadoRentasComponent) listado_rentas_component: ListadoRentasComponent;
    @ViewChild(ListadoMantenimientosComponent) listado_mantenimientos_component:ListadoMantenimientosComponent;
    @ViewChild(ListadoServiciosComponent) listado_servicios_component:ListadoServiciosComponent;
    @ViewChild(ListadoArchivosComponent) listado_archivos: ListadoArchivosComponent;

    public contrato:any={
        estatus_creacion: "BORRADOR",
        proveedor:{},
        obligados_solidarios:[{}],
        rentas:[],
        mantenimientos:[],
        servicios: [],
        archivos: [],
        otros_archivos: []
    };

    constructor(private route: ActivatedRoute,
                private router: Router,
                private cuentasPorCobrarService: CuentasPorCobrarService) {
    }

    ngOnInit() {
        this.route.params.subscribe(params => {
        var id_contrato = params['id'];
            if(id_contrato){
                this.loadContrato(id_contrato);
            }
        });
    }

    // MAIN SECTIONS FUNCTIONS     
    writePermission() {
        return true;
    }

    canExport() {
        return true;
    }

    loadContrato(id_contrato){
        this.loading = true;
        this.cuentasPorCobrarService.recuperarContrato(id_contrato)
        .subscribe(
            (response)=> {
                this.loading = false;
                let content = response.json().content;
                this.updateContratoToChildren(content);
            
            },
            (error) => {
            this.loading = false;
            }
        );
    }

    updateContratoToChildren(contrato){
        this.contrato = contrato;
        var parent = this;

        setTimeout(function(){
            parent.formulario_contrato_component.loadContrato();
            parent.listado_rentas_component.loadContrato();
            parent.listado_mantenimientos_component.loadContrato();
            parent.listado_archivos.loadFiles();
        },1000);
    }

    contratoGuardado(from_step, contrato_wrapper){
        var callback = contrato_wrapper.callback;
        var go_to_next_page = contrato_wrapper.go_to_next_page;
        var contrato = contrato_wrapper.contrato;
        this.contrato = contrato;
        
        //El paso 5 es el último paso.
        if(go_to_next_page){
            this.contrato.next_page = from_step < 5 ? (from_step + 1) : 5;
        } else{
            this.contrato.next_page = null;
        }

        if(from_step==5){
            //TODO: Modal de confirmación
            if(!confirm("¿Estas seguro que deseas finalizar la creación de tu contrato? Ya no podrá tener modificaciones por tí, sino solo mediante convenios de modificación de los administradores")) return;
            this.contrato.finalizar_contrato = true;
        }
        this.guardarContrato(from_step, go_to_next_page, callback);
    }

    guardarContratoFromTab($event,tab){
        if($event){
            //Si voy un tab hacia adelante, valido
            if(tab>this.current_tab){
                var current_component = this.getCurrentComponent();
                if(current_component && current_component.validar && !current_component.validar()){
                    $event.stopPropagation();
                    return;
                }
            }

            this.contrato.next_page = tab;
            this.current_tab=tab;

            let component = this;
            this.guardarContrato(0,false,false);
        }
    }
    getCurrentComponent():any{
        if(this.current_tab==1){
            return this.formulario_contrato_component;
        }else if(this.current_tab==2){
            return this.listado_rentas_component;
        }else if(this.current_tab==3){
            return this.listado_mantenimientos_component;
        }else if(this.current_tab==4){
            return this.listado_servicios_component;
        }else if(this.current_tab==5){
            return this.listado_archivos;
        }
        return null;
    }
    guardarContrato(from_step, go_to_next_page, callback){
        this.loading=true;
        this.cuentasPorCobrarService.guardarContrato(this.contrato)
        .subscribe(
            response=>{
                window.scrollTo(0, 0);
                this.loading=false;
                if(callback)callback();
                let content = response.json().content;
                this.updateContratoToChildren(content);
                if(go_to_next_page){
                    if(from_step==1){
                        this.goToStep(2);
                    }else if(from_step==2){
                        this.goToStep(3);
                    }else if(from_step==3){
                        this.goToStep(4);
                    }else if(from_step==4){
                        this.goToStep(5);
                    }
                }

                if(from_step==5){
                    this.router.navigate(['contratos']);
                }
            },
            error=>{
                
                this.loading=false;
                let errores = error.json();
                if(callback)callback();

                //Si hubo errores en las rentas, navegar el wizar al tab de rentas
                if(errores.content && (errores.content.fecha_inicio || errores.content.fecha_fin)){
                    this.listado_rentas_component.mostrarErroresEnGuardado(error.json());
                    this.goToStep(2);
                }else{
                    alert("ERROR: "+JSON.stringify(error));
                }
            }
        );
    }

    goToStep(step){
        document.getElementById('section_'+step).click();
    }
}


// WEBPACK FOOTER //
// ./src/app/components/contratos/agregar-contrato/agregar-contrato.component.ts